import {sbEditable} from '@storyblok/storyblok-editable';
import PropTypes from 'prop-types';

import {Text} from '../../ui';
import css from '../styles/SpecialField.module.css';
import CommonSectionLayout from './CommonSectionLayout';

const SpecialField = ({blok}) => {
  const {title, description, pt, pb, pr, pl, mt, mb} = blok;

  return (
    <div
      className={css.wrapper}
      {...sbEditable(blok)}
      style={{
        marginTop: mt,
        marginBottom: mb,
      }}
    >
      <CommonSectionLayout
        pt={pt}
        pb={pb}
        pr={pr}
        pl={pl}
        title={title}
        content={
          <>
            <Text
              lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
              color={Text.COLOR.GREY}
              className={css.subtitle}
            >
              {description}
            </Text>
            <ul className={css.list}>
              {blok.list.map(({field, _uid}) => (
                <li className={css.listItem} key={_uid}>
                  {field}
                </li>
              ))}
            </ul>
          </>
        }
      />
    </div>
  );
};

SpecialField.propTypes = {
  blok: PropTypes.object.isRequired,
};

export default SpecialField;
